const linkCheckId = (checkId, vinLink, govLink) => {
  const isVin = [
    '322221ab-4fa1-498b-9741-0e990cd3a754', // Проверка ТС по VIN Idx
    '522221ab-4fa1-498b-9741-0e990cd3a754', // Проверка ТС по VIN на участие в ДТП и ограничения Idx
    'b22221ab-4fa1-498b-9741-0e990cd3a754', // Проверка ТС Reputation - по vin номеру проводится
  ];

  const isGovNum = ['722221ab-4fa1-498b-9741-0e990cd3a754', '822221ab-4fa1-498b-9741-0e990cd3a754'];

  const isVinCheckId = isVin.some((item) => checkId?.includes(item));
  const isGovNumCheckId = isGovNum.some((item) => checkId?.includes(item));

  if (vinLink && govLink) {
    return `?check_id=${checkId}&vin=${vinLink}&license_plate=${govLink}`;
  }

  if (vinLink && isGovNumCheckId) {
    return `?vin=${vinLink}`;
  }

  if (vinLink) {
    return `?check_id=${checkId}&vin=${vinLink}`;
  }

  if (govLink && !isVinCheckId) {
    return `?check_id=${checkId}&license_plate=${govLink}`;
  }

  if (isVinCheckId && govLink && !vinLink) {
    return `?license_plate=${govLink}`;
  }

  return '';
};

export default linkCheckId;
